import script from "./AttributesValidationsMixin.vue?vue&type=script&lang=js"
export * from "./AttributesValidationsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__